<template>
    <div :class="apptype == 'Roewe' ? 'rw_home' : 'mg_home'" :style="styleOverflew">
        <div class="kv">
            <div class="shipping-address" @click.stop="deliveryAddressFun(1)"></div>
            <div class="activity-rules" @click="activityRules"></div>
            <!-- <div class="offline-clock" @click="offlineClockFun"></div> -->
        </div>
        <div class="content" :style="(apptype=='Roewe'&&activity=='two')?'height:22.5rem;':(apptype=='Roewe'&&activity=='three')?'height:30rem;':''">
            <div v-if="apptype=='Roewe'" class="stage">
                <img v-if="activity=='one'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211019a1c237d4a062cf12502073.png" alt="">
                <img v-if="activity=='two'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101962a06aa86618811b289409.png" alt="">
                <img v-if="activity=='three'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211019ae0a9f54fd5d7b92293364.png" alt="">
            </div>
            <div v-if="apptype=='MG'" class="stage">
                <img v-if="activity=='one'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015314f00c30a392bc9958356.png" alt="">
                <img v-if="activity=='two'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110199d66638ab0b9d4e9137842.png" alt="">
                <img v-if="activity=='three'" class="stage-one" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211022e77e1c31cd093409482417.png" alt="">
            </div>
            <div class="activity-one">
                <div class="profound-story" v-if="profoundStory">
                    <div class="story-title" v-if="apptype=='Roewe'">在你的记忆中，你和荣威的哪段故事让你印象最深刻呢？</div>
                    <div class="story-title" v-if="apptype=='MG'">在你的记忆中，你和MG的哪段故事让你印象最深刻呢？</div>
                    <div class="option-a flex align-items-center" @click="selectStoryFun('a')"><p><span v-if="selectStory=='a'"></span></p>A、第一次见到爱车的模样</div>
                    <div class="option-b flex align-items-center" @click="selectStoryFun('b')"><p><span v-if="selectStory=='b'"></span></p>B、第一次给爱车做保养</div>
                    <div class="option-c flex align-items-center" @click="selectStoryFun('c')"><p><span v-if="selectStory=='c'"></span></p>C、第一次和爱车一起出游</div>
                    <div class="change-story" @click="confirmSelectStory"></div>
                </div>
                <div class="reminiscence-photo-album" v-if="reminiscencePhotoAlbum">
                    <div class="drawing" @touchend="touchendFun" @touchstart="touchStartFun(0)"></div>
                    <img class="img" :class="{'fade-in':phasesChoose==1}" @touchend="touchendFun" @touchstart="touchStartFun(1)" v-if="phasesChoose==1" :src="photoAlbum.one" alt="">
                    <img class="img" :class="{'fade-in':phasesChoose==2}" @touchend="touchendFun" @touchstart="touchStartFun(2)" v-if="phasesChoose==2" :src="photoAlbum.two" alt="">
                    <img class="img" :class="{'fade-in':phasesChoose==3}" @touchend="touchendFun" @touchstart="touchStartFun(3)" v-if="phasesChoose==3" :src="photoAlbum.three" alt="">
                    <img class="img" :class="{'fade-in':phasesChoose==4}" v-if="phasesChoose==4" :src="photoAlbum.four" alt="">
                    <div class="album-title">
                        <div class="title" v-if="albumTitleOne&&apptype=='MG'">动动手指长按方框~一起制作属于你和MG的专属回忆相册吧~（长按请耐心点哦~，完成一次相册绘画可获得50积分，最终绘画完后有机会获得一个礼包哦～）</div>
                        <div class="title" v-if="albumTitleOne&&apptype=='Roewe'">动动手指长按方框~一起制作属于你和荣威的专属回忆相册吧~(长按请耐心点哦~，完成一次相册绘画可获得50积分，最终绘画完后有机会获得一个礼包哦～)</div>
                        <div class="title-two" v-if="albumTitleOne==false">点击分享至朋友圈后可<span>额外获得100积分</span>(完成一次相册绘画可获得50积分，最终绘画完后有机会获得一个礼包哦～)</div>
                        <div class="btn-list flex justify-content-center align-items-center" v-if="albumTitleOne==false">
                            <div class="share-btn" @click="share"></div>
                            <!-- <div class="next-btn" v-if="nextBtn" @click="nextBtnFun"></div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="activity-two" v-if="activity=='two' || activity=='three'">
                <div class="inflation-tire" v-if="gettingAroundEssential==0">
                    <img @click="inflationTireFun(0)" :src="inflationTire" alt="" v-if="inflationTire">
                    <div class="title">快快快~我们赶紧准备下参加双十一狂欢节~快为我打气，我要上路啦~（点击图片完成一次准备工作为可获得100积分，完成所有准备工作有机会获得惊喜礼包哦～）</div>
                </div>
                <div class="car-wash" v-if="gettingAroundEssential==1">
                    <img @click="inflationTireFun(1)" :src="carWash" alt="">
                    <div class="title">快快快~我们赶紧准备下参加双十一狂欢节~快为我洗洗，我要帅气地上路~（点击图片完成一次准备工作为可获得100积分，完成所有准备工作有机会获得惊喜礼包哦～）</div>
                </div>
                <div class="refuel" v-if="gettingAroundEssential==2">
                    <img @click="inflationTireFun(2)" :src="gettingAroundEssentialList[2].url" alt="">
                    <div class="title">快快快~我们赶紧准备下参加双十一狂欢节~快给我加满油，我要去看看世界（点击图片完成一次准备工作为可获得100积分，完成所有准备工作有机会获得惊喜礼包哦～）</div>
                </div>
                <div class="reach-store-examine" v-if="gettingAroundEssential==3 || gettingAroundEssential==4">
                    <img @click="inflationTireFun(3)" :src="gettingAroundEssentialList[3].url" alt="">
                    <div class="title">快快快~我们赶紧准备下参加双十一狂欢节~快给我全身检查下，我要健健康康地去~（点击图片完成一次准备工作为可获得100积分，完成所有准备工作有机会获得惊喜礼包哦～）</div>
                </div>
                
                <!-- <div class="two-next-btn" v-if="twonextBtn" @click="twonextBtnFun"></div> -->
            </div>
            <div class="activity-three" v-if="activity=='three'">
                <img class="map" :src="activityThreeMap" alt="">
                <div class="title">我们要上路咯~坐稳啦！听说到达景点有意外收获哦~快和我一起去探索吧！（点击出发完成一次探索有机会获得150积分，完成所有探索有机会获得一个礼包哦～笔记本电脑和小米除螨仪等你来拿～）</div>
                <div class="depart-btn" @click="depareBtn"></div>
            </div>
            <div class="commodity-update">
                <div class="commodity-list flex justify-content-between align-items-center">
                    <img :src="item.img" alt="" v-for="(item,index) in commodityList" :key="index" @click="commodityFun(item)">
                </div>
                <div class="commodity-btn" @click="commodityBtn"></div>
            </div>
        </div>
        <!-- 返回按钮 -->
        <div class="close_page" @click="closepage"></div>
        <!-- toast弹框 -->
        <div class="toast" v-if="toastPopup">{{toastContent}}</div>
        <!-- 弹框 -->
        <div class="mask" v-if="regulationPopup || envelopePopup ||letterPaper || acquisitionIntegral || thanksParticipation || tipsFillAddressIinformation || sectionHighwayRailway || prizeIntegralPopup">
            <!-- 三阶段地图路段选择 -->
            <div class="section-highway-railway positionabsolute" v-if="sectionHighwayRailway">
                <div class="close-acquisition" @click="closesectionHighwayRailway"></div>
                <div class="btn-list flex justify-content-center">
                    <div class="left-btn" @click="leftBtnFun"></div>
                    <div class="right-btn" @click="rightBtnFun"></div>
                </div>
            </div>            
            <!-- 提示填写信息弹框 -->
            <div class="tips-fill-address-information positionabsolute" v-if="tipsFillAddressIinformation">
                <div class="close-acquisition" @click="closetipsFillAddressIinformation"></div>
            </div>
            <!-- 信封 -->
            <div class="envelope-popup positionabsolute" v-if="envelopePopup">
                <div class="open-envelope" @click="openEnvelopePopup"></div>
            </div>
            <!-- 信纸 -->
            <div class="letter-paper-popup positionabsolute" v-if="letterPaper">
                <div class="open-letter-paper" @click="letterPaperPopup"></div>
            </div>
            <!-- 获得50积分 -->
            <div class="acquisition-integral positionabsolute" v-if="acquisitionIntegral">
                <div class="close-acquisition" @click="closeAcquisitionIntegral"></div>
                <div class="acquisition-title">恭喜您获得<span>{{prizeTitle}}</span></div>
                <img class="prize-img" :src="prizeImg" alt="">
                <div class="prize-title">{{prizeTitle}}</div>
                <div class="confirm-btn" @click="closeAcquisitionIntegral"></div>
            </div>
            <!-- 获得奖品和积分弹框 -->
            <div class="prize-integral-popup" v-if="prizeIntegralPopup">
                <div class="close-acquisition" @click="closeprizeIntegralPopup"></div>
                <div class="acquisition-title">恭喜您获得<span>{{prizeTitle}}</span></div>
                <img class="prize-img" :src="prizeImg" alt="">
                <div class="prize-title">{{prizeTitle}}</div>
                <div class="acquisition-title2" v-if="prizeTitle2!=='谢谢参与'">恭喜您获得<span>{{prizeTitle2}}</span></div>
                <img class="prize-img2" :src="prizeImg2" alt="">
                <div class="prize-title2" :style="(prizeTitle2=='谢谢参与')?'position: absolute;left: 50%;transform: translateX(-50%);bottom: 3rem;font-size: 0.8rem;':''">{{prizeTitle3}}</div>
                <div v-if="confirmAddress" class="confirm-btn" @click="closeprizeIntegralPopup"></div>
                <div v-if="confirmAddress==false" class="confirm-address-btn" @click="deliveryAddressFun(prizeTitle2=='谢谢参与'?'':prizeTitle2)"></div>
            </div>
            <!-- 谢谢参与弹框 -->
            <div class="thanks-participation positionabsolute" v-if="thanksParticipation">
                <div class="close-acquisition" @click="closethanksParticipation"></div>
            </div>
            <!-- 规则弹框 -->
            <div class="regulation-popup positionabsolute" v-if="regulationPopup">
                <div class="regulation-content">
                    <p class="title">一、活动时间</p>
                    <p>2021年10月18日-2021年10月31日 共14天</p>
                    <p class="title">二、活动说明</p>
                    <p>本次十月活动以用户受邀参与双十一狂欢节出行前的准备活动为活动任务。本次活动分为三个阶段，用户每达到一个阶段要求即可获得该阶段奖励。通过阶段任务的用户可获得积分，双十一兑换券奖励与礼包奖励，所有获得的奖品在活动页面的收货地址中可查看。</p>
                    <!-- <p class="title">1、第一阶段：2021.10.18-2021.10.31</p> -->
                    <div class="rule-one"></div>
                    <p>1. 用户每日可描绘自己和爱车的回忆相片并可获得50积分，每日一次。</p>
                    <p>2. 当用户描绘完回忆相片后可进入下一阶段，分享回忆相片至朋友圈可额外获得100积分。</p>
                    <p>3.奖品设置如下：</p>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>奖品名称</th><th>数量</th></tr>
                        <tr><td>腾讯视频月卡</td><td>1500</td></tr>
                        <tr><td style="width:75%;">100积分</td><td style="width:25%;">2000</td></tr>
                    </table>
                    <div class="rule-two"></div>
                    <!-- <p class="title">2、第二阶段：2021.10.18-2021.10.31</p> -->
                    <p>1. 用户通过上一阶段任务后，用户每日可为爱车完成准备工作去旅行并可获得100积分，每日一次。</p>
                    <p>2. 当用户为爱车做完准备工作后可进入下一阶段，并获得200积分与随机礼包。</p>
                    <p>3.奖品设置如下：</p>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>奖品名称</th><th>数量</th></tr>
                        <tr><td>猫眼电影通兑券</td><td>196</td></tr>
                        <tr><td style="width:75%;">100积分</td><td style="width:25%;">2000</td></tr>
                    </table>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>双十一兑换券</th><th>数量</th></tr>
                        <tr><td style="width:75%;">猫眼电影通兑券</td><td style="width:25%;">898</td></tr>
                    </table>
                    <div class="rule-three"></div>
                    <!-- <p class="title">3、第三阶段：2021.10.18-2021.10.31</p> -->
                    <p>1. 用户通过上一阶段任务后，用户每日可选择自己要去的途径点，到达一个节点（不可重复领取同一个途径点奖励）即可获得150积分，每日两次。</p>
                    <p>2. 每两个途径点有一个大礼包，达到第6点即可获得最终大奖和300积分。</p>
                    <p>3.奖品设置如下：</p>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>奖品名称</th><th>数量</th></tr>
                        <tr><td>Surface Laptop Go i5(256G)</td><td>3</td></tr>
                        <tr><td>倍轻松（breo）腰部按摩器</td><td>16</td></tr>
                        <tr><td style="width:75%;">小米除螨仪家用手持除螨机</td><td style="width:25%;">35</td></tr>
                        <tr><td>犇犇的小野牛巨型零食包</td><td>188</td></tr>
                        <tr><td>100积分</td><td>2000</td></tr>
                    </table>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>双十一兑换券</th><th>数量</th></tr>
                        <tr><td>猫眼电影通兑券</td><td>800</td></tr>       
                        <tr><td>Surface Laptop Go i5(256G)</td><td>6</td></tr>
                        <tr><td>倍轻松（breo）腰部按摩器</td><td>36</td></tr>
                        <tr><td style="width:75%;">小米除螨仪家用手持除螨机</td><td style="width:25%;">266</td></tr>
                        <tr><td>犇犇的小野牛巨型零食包</td><td>800</td></tr>
                    </table>
                    <p>本次活动的奖励中含惊喜双十一兑换券等待您的探索。抽中双十一兑换券的用户不要着急，双十一当天<span>登陆App或者天猫上汽售后旗舰店</span>完成<span>双十一保养商品的订单</span>并在11.28日之前完成核销，即可获得兑换券上的好礼，奖品将会在订单核销/确认收货后10个工作日内发出。</p>
                    <div class="rule-four"></div>
                    <!-- <p class="title">活动注意事项：</p> -->
                    <p>1.用户中奖后需在<span>2021年10月31日</span>前在活动页面“<span>收货信息</span>”填写收货信息，奖品于活动结束后的20个工作日内发放。如因未及时填写收货信息或收货信息错误而导致的后果，由用户自行承担；如出现不可抗力或情势变更的情况（例如物流政策变更导致奖品无法按计划发放），用户需理解活动主办方可依相关法律规定主张免责。</p>
                    <p>2.参与活动获得的领奖权益不可转赠他人，所有奖品不可折现、不可退换。</p>
                    <p>3.用户应充分了解本活动所设的活动规则并遵照执行。如经核实用户有违规、作弊等情况，除按照相关协议及规则处理外，所获活动权益也可能被取消。</p>
                    <p>4.本次活动设计的奖品以实物为准，图片所展示的奖品颜色仅供参考，不作为最终发放标准。</p>
                    <p>5.活动规则可能根据本活动实际情况进行调整，调整后的规则将公布在活动页面上，并于公布时即时生效。</p>
                </div>
                <div class="regulation-btn" @click="closeRegulationPopup"></div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
        return {
            confirmAddress:false,  //地址按钮，true为确定，false为填写
            prizeIntegralPopup:false,  //奖品积分弹框
            acThreeStage:3,  //三阶段进行到哪一步
            activityThreeMap:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d6e5d7aa201503df516311.jpg',  //三阶段地图
            mapList:[
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d6e5d7aa201503df516311.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021336766a09d89d9e6630350.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d8937ea9406b2b28563888.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110217bb3edbc8bb2b214915018.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102123761342f20de85a654442.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d130e87b9fd39118828387.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110215c101df37448411e294430.jpg',
            ],  //三阶段地图列表
            sectionHighwayRailway:false,  //三阶段路段选择
            gettingAroundEssential:0,
            tipsFillAddressIinformation:false,   //提示填写地址信息弹框
            thanksParticipation:false,   //谢谢参与弹框
            nextBtn:false,  //是否开启第二阶段
            twonextBtn:false,  //是否开启第三阶段
            activity:'three',  //当前处于哪一个阶段，one,two,three
            prizeTitle:'200积分',  //奖品名称
            prizeImg:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png',  //奖品图
            prizeTitle2:'券：猫眼电影通兑券',  //奖品名称
            prizeTitle3:'双十一兑换券使用方法请见活动规则',  //奖品名称
            prizeImg2:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020600f62a37d383053743055.png',  //奖品图
            albumTitleOne:true,  //第一阶段文字
            styleOverflew:'overflow-y: scroll;',
            apptype: "Roewe",  //roewe为名荣威  mg为名爵
            userToken: "96f4271631fd46e29a8a7df2338b70e7-qa_SAIC", // 用户token
            // userToken: "00cb3f6fa39042f19eb001e8f608e7cf-prod_SAIC", // 用户token
            toastPopup:false,  //toast提示弹框
            toastContent:'',  //toast提示内容
            address:{},   //地址信息
            nextreturn:true,  //防止二次点击
            userinfo:{},  //用户信息
            scource:'',
            acquirePrizes:[],   //奖品信息
            commodityList:[
                {
                    link:'https://prw.anyolife.com/goods-detail/2c908af372cc62fc0172df37dfc00549',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015b46e90c29d0f4f19708298.png',
                    name:'腾讯视频季卡'
                },
                {
                    link:'https://prw.anyolife.com/goods-detail/4748821b7a5330d3017a5592b7f33156',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101548108b1f4456c038537477.png',
                    name:'清风抽纸3层'
                },
                {
                    link:'https://prw.anyolife.com/goods-detail/2c908af3798eb2120179a1bfaeb73ec5',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110186398c41a6cdba424580207.png',
                    name:'吸尘器套装'
                },
            ],  //商品列表
            regulationPopup:false,  //规则弹框
            envelopePopup:true,   //信封
            letterPaper:false,   //信纸
            selectStory:0,  //深刻故事的选择
            profoundStory:true,  //是否已经选择过深刻故事
            reminiscencePhotoAlbum:false,   //回忆相册
            phasesChoose:0,  //第一阶段第几天，one two three four
            drawingTime:'',  //第二阶段的计时器
            acquisitionIntegral:false,  //获得50积分
            shareOf:true,  //是否已经分享过
            completeStatusOne:2,  //今天是否参加过一阶段活动
            completeStatusTwo:2,  //今天是否参加过一阶段活动
            completeStatusThree:2,  //今天是否参加过一阶段活动
            photoAlbumList:[
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015dd271b74cab842f2932779.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110155a1cdcd9ea2b0c84243114.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110153d02d62878a987cf427265.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101591987c00ee96a2e4854434.jpg',
                },
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015c9edc37367a1f147473150.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015bf88f7aa18a92d3e464900.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110150a0cc525658b85e1180670.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110152445950b9227dc44594609.jpg',
                },
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015946593197b14fd5f775118.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015f200b31cd8c0e4bc536885.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015bdeeb0665a0e5f52956538.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015cc07fbeda73314db746215.jpg',
                },
            ],  //荣威第一阶段相册图片
            gettingAroundEssentialList:[
                [
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020d02c7745cc191d58705303.jpg',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102090dd8ad76013444a228398.jpg'
                ],
                [
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110208e53a640e56c13a2648317.jpg',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020bb9c337617e582ad921276.jpg',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020e766265898a4eb64923209.jpg',
                ],
                {
                    url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110200a4d8c35401e2f50890493.jpg'
                },
                {
                    url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020067d1dab2aedd60b476210.jpg'
                }
            ],
            carWash:"https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110208e53a640e56c13a2648317.jpg",
            inflationTire:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020d02c7745cc191d58705303.jpg',  //二阶段第一天活动的图片内容
            photoAlbum:{},  //荣威第一阶段相册图片
            shareTitle:'',  //分享文案
            shareImge:'',  //分享图
            shareLink:'',  //分享链接
            n:0,
            m:0
        };
    },
  mounted() {
        if (this.apptype == "Roewe") {
            require("../../public/css/rw.less");
            this.shareTitle = '荣威 | 启程享狂欢，好礼送不停'
            this.shareImge = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101603cf355da673d809700655.jpg'
            this.shareLink = 'https://gio.ren/d8jZ?path=/RouterManager/openCustomWebViewController/publicService&params=eyJVUkwiOiJodHRwczovL2g1Y2FzZTQueGlhb3h4eC5jbi8yMDIxMTAvcm9ld2UvZGlzdC9pbmRleC5odG1sIn0='
        } else {
            this.shareTitle = 'MG | 启程享狂欢，好礼送不停'
            this.shareImge = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110164b4b8116e2a0928f633888.jpg'
            this.shareLink = 'https://gio.ren/dOGQ?path=/mgBase/baseDsBridgePage&params=eyJrZXlfZHNfdXJsIjoiaHR0cHM6Ly9oNWNhc2U0LnhpYW94eHguY24vMjAyMTEwL21nL2Rpc3QvaW5kZXguaHRtbCIsImtleV9kc19uYXZpZ2F0aW9uX2JhciI6IjIiLCJrZXlfZHNfdGl0bGUiOiLlkI3niLUifQ=='
            this.commodityList=[
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af372cc62fc0172df37dfc00549',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101518ddba4e1d349e28779688.png',
                    name:'腾讯视频季卡'
                },
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af3798eb2120179a1f576953ef5',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101800ba56370a169f26595711.png',
                    name:'Trophy League格栅徽标盾形'
                },
                {
                    link:'https://mg.anyolife.com/goods-detail/4748821b798eb4f80179a725739f3ecb',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101802646bb9afbc471d120564.png',
                    name:'名爵x飞跃定制鞋'
                },
            ]
            this.photoAlbumList = [
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015f599635b0729415b352634.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110151df3e0ad7191561f579420.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110150fbd9e7e4f63e0d6156981.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110158c103a784623c1b4273520.jpg',
                },
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015df34f2ddd7f0c69c779650.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015fa8112d5d9082b47183453.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015829dcb23b359dd6d932088.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101586fa5a57c500f62b255683.jpg',
                },
                {
                    one:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110154563f524018972cd671971.jpg',
                    two:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015c80476daf914aa07460929.jpg',
                    three:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101583a6aa8f52edf2fa885633.jpg',
                    four:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015f000b5931a4501b4948471.jpg',
                },
            ]
            this.gettingAroundEssentialList=[
                [
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110207a85546d664441a5756082.jpg',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020d0b5cc1d26d68c18746687.jpg'
                ],
                [
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020a58c1fbb425e94b9887555.png',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020acb5b410b390d6e5890603.png',
                    'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110206fa7840b2ca91c5f556515.png',
                ],
                {
                    url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102012774ca02f4bce5b345055.jpg'
                },
                {
                    url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102051a3dc8d48ce18d9948042.jpg'
                }
            ]
            this.carWash="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020a58c1fbb425e94b9887555.png"
            this.inflationTire='https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110207a85546d664441a5756082.jpg'
            this.activityThreeMap='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021b857f22f0d425842780572.jpg'
            this.mapList=[
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021b857f22f0d425842780572.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110210030fd5ca45d2c9b873020.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021957eb2acdd0bbd8c569133.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110212561a209c5c889b7536771.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021c01b99566924bf51324156.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021285fd873fd169690285094.jpg',
                'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021953391605182fa53125703.jpg',
            ],
            require("../../public/css/mg.less");
        }
    },
    created() {
        if(window.location.href.indexOf('?')==-1){
            this.scource = 'index'
        }else{
            this.scource = this.getSearchString('scource',window.location.href)
        }
        if(this.scource.indexOf('#')==-1){
            this.scource = this.scource
        }else{
            this.scource = this.scource.split('#')[0]
        }
        if(window.localStorage.getItem('envelope')){
            this.envelopePopup = false
            this.styleOverflew='overflow-y: scroll;'
        }else{
            this.envelopePopup = true
            this.styleOverflew='overflow-y: hidden;'
        }
        this.apptype = 'MG'
        // if(window.localStorage.getItem('zebra-token')){
        //     this.userToken = window.localStorage.getItem('zebra-token')
        //     this.getlist()
        // }else{
            this.getUserToken();
        // }
        // this.getlist()
    },
    methods: {
        // 关闭奖品积分弹框
        closeprizeIntegralPopup(){
            this.prizeIntegralPopup = false
            this.styleOverflew='overflow-y: scroll;'
        },
        // 选择右边的路
        rightBtnFun(){
            this.activityThreeFun()
        },
        // 选择左边的路
        leftBtnFun(){
            this.$http.post("/leftBack", {
                brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
            }).then((res)=>{
                if(res.data.code==0){
                    this.sectionHighwayRailway = false
                    this.styleOverflew='overflow-y: scroll;'
                    this.activityThreeMap = ''
                    this.acThreeStage--
                    this.activityThreeMap = this.mapList[this.acThreeStage]
                    this.toastContent = '走不了啦~记得选右边畅通的路啦！'
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                        this.getlist()
                    }, 1500);
                }else{
                    this.activityThreeMap = ''
                    this.acThreeStage--
                    this.activityThreeMap = this.mapList[this.acThreeStage]
                    this.sectionHighwayRailway = false
                    this.styleOverflew='overflow-y: scroll;'
                    if(this.hasLetter(res.data.message)){
                        this.styleOverflew='overflow-y: scroll;'
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            })
        },
        // 三阶段出发
        depareBtn(){
            if(this.completeStatusThree==1){
                this.toastContent='今天已达到上限'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent=''                    
                }, 1500);
                return false
            }
            if(this.nextreturn && this.acThreeStage<6){
                this.nextreturn = false
                this.activityThreeMap = ''
                this.acThreeStage++
                this.activityThreeMap = this.mapList[this.acThreeStage]
                this.nextreturn = true
                setTimeout(() => {
                    if(this.acThreeStage % 2 === 1){
                        this.activityThreeFun()
                    }else if( this.acThreeStage % 2 === 0){
                        this.sectionHighwayRailway = true
                        this.styleOverflew='overflow-y: hidden;'
                    }
                }, 500);
            }else if(this.acThreeStage==6){
                this.toastContent = '您已到达终点'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
            }
        },
        activityThreeFun(){
            this.$http.post("/completeActivityThree", {
                brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
            }).then((res)=>{
                if(res.data.code==0){
                    this.sectionHighwayRailway = false
                    this.styleOverflew='overflow-y: scroll;'
                    window._czc.push(["_trackEvent", this.scource, "三阶段活动", "1", "1", "1"]);
                    if(JSON.stringify(res.data.data.prizeInfo)!='[]'){
                        if(this.acThreeStage==6){
                            this.prizeTitle='300积分'

                        }else{
                            
                            this.prizeTitle='150积分'
                        }
                        if(res.data.data.prizeInfo.prize_name=='谢谢参与'){
                            this.prizeImg2=''
                            if(this.apptype=='Roewe'){
                                this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                            }
                            this.prizeTitle2 = '谢谢参与'
                            this.prizeTitle3 = '谢谢参与'
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='Surface Laptop Go i5 （256G）'){
                            // this.prizeTitle='300积分'
                            this.prizeTitle2='Surface Laptop Go i5 (256G)'
                            this.prizeTitle3 = 'Surface Laptop Go i5 (256G)'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021af0c790a289a77bf597686.jpg'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d74a182164cd2db5795993.png'
                            }
                            this.confirmAddress = false
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='券：Surface Laptop Go i5 （256G）'){
                            // this.prizeTitle='300积分'
                            this.prizeTitle2='券：Surface Laptop Go i5 (256G)'
                            this.prizeTitle3 = '双十一兑换券使用方法请见活动规则'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021af0c790a289a77bf597686.jpg'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021d74a182164cd2db5795993.png'
                            }
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='倍轻松（breo）腰部按摩器' || res.data.data.prizeInfo.prize_name=='券：倍轻松（breo）腰部按摩器'){
                            // this.prizeTitle='300积分'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110210ba3f420ea067d56138119.jpg'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110212d3ae2b38cd2d0b9175122.png'
                            }
                            if(res.data.data.prizeInfo.prize_name=='倍轻松（breo）腰部按摩器'){
                                this.prizeTitle2='倍轻松(breo)腰部按摩器'
                                this.prizeTitle3 = '倍轻松(breo)腰部按摩器'
                                this.confirmAddress = false
                            }else{
                                this.prizeTitle2='券：倍轻松(breo)腰部按摩器'
                                this.prizeTitle3 = '双十一兑换券使用方法请见活动规则'
                                this.confirmAddress = true
                            }
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='小米除螨仪家用手持除螨机' || res.data.data.prizeInfo.prize_name=='券：小米除螨仪家用手持除螨机'){
                            // this.prizeTitle='300积分'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021a12c50a62cd01972830943.jpg'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021362b216502816ecc285662.png'
                            }
                            if(res.data.data.prizeInfo.prize_name=='小米除螨仪家用手持除螨机'){
                                this.prizeTitle2=res.data.data.prizeInfo.prize_name
                                this.prizeTitle3 = res.data.data.prizeInfo.prize_name
                                this.confirmAddress = false
                            }else{
                                this.prizeTitle2='券：小米除螨仪家用手持除螨机'
                                this.prizeTitle3 = '双十一兑换券使用方法请见活动规则'
                                this.confirmAddress = true
                            }
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='券：犇犇的小野牛巨型零食包' || res.data.data.prizeInfo.prize_name=='犇犇的小野牛巨型零食包'){
                            // this.prizeTitle='300积分'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110219a0af5bac6f5da2e213154.jpg'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102170410760b7fb5604237446.png'
                            }
                            if(res.data.data.prizeInfo.prize_name=='犇犇的小野牛巨型零食包'){
                                this.prizeTitle2=res.data.data.prizeInfo.prize_name
                                this.prizeTitle3 = res.data.data.prizeInfo.prize_name
                                this.confirmAddress = false
                            }else{
                                this.prizeTitle2='券：犇犇的小野牛巨型零食包'
                                this.prizeTitle3 = '双十一兑换券使用方法请见活动规则'
                                this.confirmAddress = true
                            }
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='100积分'){
                            // this.prizeTitle='300积分'
                            this.prizeTitle2='100积分'
                            this.prizeTitle3 = '100积分'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                            }
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }
                        if(this.userinfo.activity==3){
                            this.twonextBtn = true
                        }
                        // if(str==4){
                        //     this.gettingAroundEssential = 3
                        // }else{
                        //     this.gettingAroundEssential = str + 1
                        // }
                    }else{
                        this.prizeTitle='150积分'
                        if(this.apptype=='Roewe'){
                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                        }else{
                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                        }
                        this.acquisitionIntegral = true
                        this.styleOverflew='overflow-y: hidden;'
                    }
                }else{
                    this.activityThreeMap = ''
                    this.acThreeStage--
                    this.activityThreeMap = this.mapList[this.acThreeStage]
                    this.sectionHighwayRailway = false
                    this.styleOverflew='overflow-y: scroll;'
                    if(this.hasLetter(res.data.message)){
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            }).catch((err)=>{
                this.activityThreeMap = ''
                this.acThreeStage--
                this.activityThreeMap = this.mapList[this.acThreeStage]
                this.sectionHighwayRailway = false
                this.styleOverflew='overflow-y: scroll;'
                this.toastContent = '系统繁忙，请稍后再试'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
                return false
            })
        },
        // 关闭地图选择弹框
        closesectionHighwayRailway(){
            this.activityThreeMap = ''
            this.acThreeStage--
            this.activityThreeMap = this.mapList[this.acThreeStage]
            this.sectionHighwayRailway = false
            this.styleOverflew='overflow-y: scroll;'

        },
        // 开启第三阶段
        twonextBtnFun(){
            this.activity = 'three'
        },
        // 二阶段活动
        inflationTireFun(str){
            if(this.completeStatusTwo==1){
                this.toastContent='今天已达到上限'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent=''                    
                }, 1500);
                return false
            }
            if(str==0){
                if(this.nextreturn && this.n<1){
                    this.nextreturn = false
                    this.inflationTire = ''
                    this.n++
                    this.inflationTire = this.gettingAroundEssentialList[0][this.n]
                    this.nextreturn = true
                    if(this.n==1){
                        this.activityTwoFun(str)
                    }
                }
            }else if(str==1){
                if(this.nextreturn && this.m<2){
                    this.nextreturn = false
                    this.carWash = ''
                    this.m++
                    this.carWash = this.gettingAroundEssentialList[1][this.m]
                    this.nextreturn = true
                    if(this.m==2){
                        this.activityTwoFun(str)
                    }
                }
            }else{
                this.activityTwoFun(str)
            }
        },
        // 二阶段参加活动接口
        activityTwoFun(str){
            this.$http.post("/completeActivityTwo", {
                brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
            }).then((res)=>{
                if(res.data.code==0){
                    window._czc.push(["_trackEvent", this.scource, "二阶段活动", "1", "1", "1"]);
                    this.completeStatusTwo = 1
                    if(JSON.stringify(res.data.data.prizeInfo)!='[]'){
                        if(res.data.data.prizeInfo.prize_name=='谢谢参与'){
                            this.prizeTitle='200积分'
                            this.prizeImg2=''
                            if(this.apptype=='Roewe'){
                                this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                            }
                            this.prizeTitle2 = '谢谢参与'
                            this.prizeTitle3 = '谢谢参与'
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='券：猫眼电影通兑券'){
                            this.prizeTitle='200积分'
                            this.prizeTitle2='猫眼电影通兑券'
                            this.prizeTitle3 = '双十一兑换券使用方法请见活动规则'
                            if(this.apptype=='Roewe'){
                                this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211019c575b50ea650ebe7171819.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020600f62a37d383053743055.png'
                            }
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='猫眼电影通兑券'){
                            this.prizeTitle='200积分'
                            this.prizeTitle2='猫眼电影通兑券'
                            this.prizeTitle3 = '猫眼电影通兑券'
                            if(this.apptype=='Roewe'){
                                this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211019ebc5ec1a2e80199e112941.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211020664ef90f00804787132673.png'
                            }
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }else if(res.data.data.prizeInfo.prize_name=='100积分'){
                            this.prizeTitle='200积分'
                            this.prizeTitle2='100积分'
                            this.prizeTitle3 = '100积分'
                            if(this.apptype=='Roewe'){
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                            }else{
                                this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                this.prizeImg2 = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                            }
                            this.confirmAddress = true
                            this.prizeIntegralPopup = true
                            this.styleOverflew='overflow-y: hidden;'
                        }
                        if(this.userinfo.activity==3){
                            this.twonextBtn = true
                        }
                        // if(str==4){
                        //     this.gettingAroundEssential = 3
                        // }else{
                        //     this.gettingAroundEssential = str + 1
                        // }
                    }else{
                        this.prizeTitle='100积分'
                        if(this.apptype=='Roewe'){
                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                        }else{
                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                        }
                        this.acquisitionIntegral = true
                        this.styleOverflew='overflow-y: hidden;'
                    }
                }else{
                    if(this.hasLetter(res.data.message)){
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            })
        },
        // 关闭提示填写地址信息弹框
        closetipsFillAddressIinformation(){
            this.tipsFillAddressIinformation = false
            this.styleOverflew='overflow-y: scroll;'
            window.localStorage.setItem('isRemind','isRemind')
        },
        // 关闭谢谢参与弹框
        closethanksParticipation(){
            this.thanksParticipation= false
            this.styleOverflew='overflow-y: scroll;'
        },
        nextBtnFun(){
            this.activity = 'two'
        },
        // 商品好物更多商品点击
        commodityBtn(){
            // if(this.userinfo.info.is_owner==1){
            //     this.track('moonFestival_gift_moreClick','',this.scource,'','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html', this.userinfo.info.user_id, 'bindUser')
            // }else{
            //     this.track('moonFestival_gift_moreClick','',this.scource, '','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html',this.userinfo.info.user_id, 'unbindUser')
            // }
            window._czc.push(["_trackEvent", this.scource, "商品列表", '更多商品列表', "1", "1"]);
            if(this.apptype=='Roewe'){
                window.location.href = 'https://prw.anyolife.com/page/poster/1634196829125/123458031'
            }else{
                window.location.href = 'https://mg.anyolife.com/page/poster/1634196260219/123458046'
            }
        },
        // 商品好物商品列表点击
        commodityFun(data){
            // if(this.userinfo.info.is_owner==1){
            //     this.track('moonFestival_gift_listClick',data.item,this.scource,'','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html', this.userinfo.info.user_id, 'bindUser')
            // }else{
            //     this.track('moonFestival_gift_listClick',data.item,this.scource, '','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html',this.userinfo.info.user_id, 'unbindUser')
            // }
            window._czc.push(["_trackEvent", this.scource, "商品列表", data.name, "1", "1"]);
            window.location.href = data.link
        },
        // 关闭50积分弹框
        closeAcquisitionIntegral(){
            this.acquisitionIntegral = false
            this.styleOverflew='overflow-y: scroll;'
        },
        // 分享至朋友圈
        share(){
            window._czc.push(["_trackEvent", this.scource, "分享至朋友圈", "1", "1", "1"]);
            if(this.shareOf){
                this.$http.post("/clickShare", {
                  brandCode: "2", // 1:荣威，2:名爵
                    token: this.userToken,
                }).then((res)=>{
                    if(res.data.code==0){
                        share( this.shareTitle, '', this.shareLink, this.shareImge, 3)
                    }else{
                        if(this.hasLetter(res.data.message)){
                            this.toastContent = '系统繁忙，请稍后再试'
                            this.toastPopup = true
                            setTimeout(() => {
                                this.toastPopup = false
                                this.toastContent = ''
                            }, 1500);
                            return false
                        }
                        this.toastContent = res.data.message
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                    }
                })
            }else{
                share( this.shareTitle, '', this.shareLink, this.shareImge, 3)
            }
            
        },
        // 第一阶段长按
        touchStartFun(num){
            if(this.completeStatusOne==1){
                this.toastContent='今天已达到上限'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent=''                    
                }, 1500);
                return false
            }
            let n = 0
            this.drawingTime = setInterval (() => {
                n++
                if(n==2){
                    clearInterval(this.drawingTime)
                    if(num==0){
                        this.phasesChoose = 1
                    }else if(num==1){
                        this.phasesChoose = 2
                    }else if(num==2){
                        this.phasesChoose = 3
                    }else if(num==3){
                        this.phasesChoose = 4
                    }
                    setTimeout(() => {
                        this.$http.post("/completeActivityOne", {
                          brandCode: "2", // 1:荣威，2:名爵
                            token: this.userToken,
                        }).then((res)=>{
                            if(res.data.code==0){
                                this.completeStatusOne = 1
                                window._czc.push(["_trackEvent", this.scource, "一阶段活动", "长按", "1", "1"]);
                                if(JSON.stringify(res.data.data.prizeInfo)!='[]'){
                                    if(res.data.data.prizeInfo.prize_name=='谢谢参与'){
                                        this.thanksParticipation = true
                                        this.styleOverflew='overflow-y: hidden;'
                                    }else if(res.data.data.prizeInfo.prize_name=='腾讯视频月卡'){
                                        this.prizeTitle='腾讯视频月卡'
                                        if(this.apptype=='Roewe'){
                                            this.prizeImg='https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016d1e237e33dffeeb7650377.png'
                                        }else{
                                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211015b88614e6a3b1ba46945800.png'
                                        }
                                        this.acquisitionIntegral = true
                                        this.styleOverflew='overflow-y: hidden;'
                                    }else if(res.data.data.prizeInfo.prize_name=='100积分'){
                                        this.prizeTitle='100积分'
                                        if(this.apptype=='Roewe'){
                                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                        }else{
                                            this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                        }
                                        this.acquisitionIntegral = true
                                        this.styleOverflew='overflow-y: hidden;'
                                    }
                                    this.albumTitleOne = false
                                    if(this.userinfo.activity==2){
                                        this.nextBtn = true
                                    }
                                }else{
                                    this.prizeTitle='50积分'
                                    if(this.apptype=='Roewe'){
                                        this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                                    }else{
                                        this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                                    }
                                    this.acquisitionIntegral = true
                                    this.styleOverflew='overflow-y: hidden;'
                                }
                            }else{
                                if(this.hasLetter(res.data.message)){
                                    this.toastContent = '系统繁忙，请稍后再试'
                                    this.toastPopup = true
                                    setTimeout(() => {
                                        this.toastPopup = false
                                        this.toastContent = ''
                                    }, 1500);
                                    return false
                                }
                                this.toastContent = res.data.message
                                this.toastPopup = true
                                setTimeout(() => {
                                    this.toastPopup = false
                                    this.toastContent = ''
                                }, 1500);
                            }
                        })
                        
                    }, 1500);
                }
                
            }, 1000);
        },
        // 判断接口是否返回全为英文
        hasLetter(str) {
            for (var i in str) {
                var asc = str.charCodeAt(i);
                if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
                    return true;
                }
            }
            return false;
        },
        touchendFun(){
            console.log('11')
             clearInterval(this.drawingTime)
        },
        // 选择深刻故事
        selectStoryFun(str){
            this.selectStory = str
        },
        // 选择好故事
        confirmSelectStory(){
            if(this.selectStory=='0'){
                this.toastContent='请选择选项'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent=''                    
                }, 1500);
                return
            }
            this.$http.post("/submitChoose", {
              brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
                choose:this.selectStory
            }).then((res)=>{
                window._czc.push(["_trackEvent", this.scource, "选择选项", "1", "1", "1"]);
                if(res.data.code==0){
                    if(this.selectStory=='a'){
                        this.photoAlbum = this.photoAlbumList[0]
                    }else if(this.selectStory=='b'){
                        this.photoAlbum = this.photoAlbumList[1]
                    }else if(this.selectStory=='c'){
                        this.photoAlbum = this.photoAlbumList[2]
                    }
                    this.profoundStory = false
                    this.reminiscencePhotoAlbum = true
                    this.getlist()
                }else{
                    if(this.hasLetter(res.data.message)){
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            })
        },
        // 开始参与活动
        letterPaperPopup(){
            this.letterPaper = false
            this.styleOverflew='overflow-y: scroll;'
            window.localStorage.setItem('envelope','envelope')
        },
        // 开启信封
        openEnvelopePopup(){
            this.letterPaper = true
            this.envelopePopup = false
            this.styleOverflew='overflow-y: hidden;'
        },
        // 关闭规则弹框
        closeRegulationPopup(){
            this.regulationPopup = false
            this.styleOverflew='overflow-y: scroll;'
        },
        // 查找字符串中是否有英文字符
        hasLetter(str) {
            for (var i in str) {
                var asc = str.charCodeAt(i);
                if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
                    return true;
                }
            }
            return false;
        },
       
        // 随机数
        random(a,b){
            return Math.round(Math.random()*(a-b)+b);
        },
        
        // 规则弹框
        activityRules(){
            this.regulationPopup = true
            this.styleOverflew='overflow-y: hidden;'
        },
        getSearchString(key, Url) {  //key为要获取的字段，url为获取字段的链接
            var str = Url;
            str = str.split('?')[1]
            // str = str.substring(1, str.length); // 获取URL中?之后的字符（去掉第一位的问号）
            // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
            var arr = str.split("&");
            var obj = new Object();
            // 将每一个数组元素以=分隔并赋给obj对象
            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
        // 阿里埋点代码
        track(action, name,source,text,url,userid, uesrtype ) {
            // if(name=='name'){
            //     var params = { userId: userid, userType: uesrtype,source:source,url:url}
            // }else{
            //     var params = { userId: userid, userType: uesrtype,source:source,url:url,name:name}
            // }
            var params = { name:name,source:source,text:text,url:url,userId: userid, userType: uesrtype}
            var _baq = window._baq || []
            //_trackEvent页面交互事件
            _baq.push(['_trackEvent', action, params])
        },
        closepage(){
            const closeWin = (closeNowWin) => {
                if (closeNowWin) {
                    //关闭当前页面回到上级
                    window.closeWebView()
                } else {
                    //回到首页
                    window.closeWebView('root')
                }
            }
            closeWin()
        },
        // 去填写收货地址
        deliveryAddressFun(data){
            if(data && data!=1){
                this.acquirePrizes.push(data)
            }
            if (this.apptype == "Roewe") {
                window.location.href = 'https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html#/rwAddress2?acquirePrizes='+JSON.stringify(this.acquirePrizes)+'&address='+JSON.stringify(this.address)
                // this.$router.push({path:'/rwAddress',query:{acquirePrizes:JSON.stringify(this.acquirePrizes),address:JSON.stringify(this.address)}})
            } else {
                window.location.href = 'https://h5case4.xiaoxxx.cn/202109/mg/dist/index.html#/mgAddress2?acquirePrizes='+JSON.stringify(this.acquirePrizes)+'&address='+JSON.stringify(this.address)
                // this.$router.push({path:'/mgAddress',query:{acquirePrizes:JSON.stringify(this.acquirePrizes),address:JSON.stringify(this.address)}})
            }
        },
        // 未登陆时调用去登录页面
        backToApp() {
            window.serviceError("14101", (res) => {
                console.log(res);
            });
        },
        // 获取用户token
        getUserToken() {
            // setInterval(() => {
            //     console.log('22')
            // }, 3000);
            if(window.getToken){
                window.getToken(this.callback);

            }else{
                this.toastContent = '系统繁忙，请稍后再试'
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 2500);
            }
        },
        // getToken回调
        callback(res) {
            // setInterval(() => {
            //     console.log('22',res)
            // }, 3000);
            if (res.token) {
                // setInterval(() => {
                //     console.log("token，", res.token);
                // }, 5000);
                window.localStorage.setItem('zebra-token',res.token)
                this.userToken = res.token;
                this.getlist();
            } else {
                console.log("token为空");

                this.backToApp();
            }
        },
        // 分享发放积分
        shareIntegral(){
            this.$http.post("/completeShare", {
            brandCode: "2", // 1:荣威，2:名爵
                token: this.userToken,
            }).then((res) => {
                if(res.data.code==0){
                    this.prizeTitle='100积分'
                    if(this.apptype=='Roewe'){
                        this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211016b1d997d03970cf65961378.png'
                    }else{
                        this.prizeImg = 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021101502aec02b7ce9fc96170601.png'
                    }
                    this.acquisitionIntegral = true
                    this.styleOverflew='overflow-y: hidden;'
                }else{
                    if(this.hasLetter(res.data.message)){
                        this.styleOverflew='overflow-y: scroll;'
                        this.toastContent = '系统繁忙，请稍后再试'
                        this.toastPopup = true
                        setTimeout(() => {
                            this.toastPopup = false
                            this.toastContent = ''
                        }, 1500);
                        return false
                    }
                    this.toastContent = res.data.message
                    this.toastPopup = true
                    setTimeout(() => {
                        this.toastPopup = false
                        this.toastContent = ''
                    }, 1500);
                }
            })
        },
        // 活动一的信息
        getlist() {
            this.acquirePrizes = []
            let that = this;
            that.$http.post("/getInfo", {
            brandCode: "2", // 1:荣威，2:名爵
                token: that.userToken,
            }).then((res) => {
                
                if(res.data.code==0){
                    window.localStorage.setItem('Authorization',res.data.data.H5Token)
                    res.data.data.prizeInfo.map((v)=>{
                        this.acquirePrizes.push(v.prize_name)
                    })
                    this.address = res.data.data.info.address || {}
                    if(res.data.data.activity==1){
                        this.activity = 'one'
                        // if(res.data.data.info.current_stage==1){
                        //     this.albumTitleOne = true
                        // }else if(res.data.data.info.current_stage==2){
                        //     this.albumTitleOne = false
                        // }
                    }else if(res.data.data.activity==2){
                        this.activity = 'two'
                        // if(res.data.data.info.current_stage==1){
                        //     this.activity = 'one'
                        //     this.albumTitleOne = true
                        //     this.nextBtn = true
                        // }else if(res.data.data.info.current_stage==2){
                        //     this.activity = 'one'
                        //     this.nextBtn = true
                        //     if(res.data.data.info.ac_two_stage>0){
                        //         this.activity = 'two'
                        //     }
                        // }else{
                        //     this.activity = 'two'
                        //     this.twonextBtn = true
                        //     if(res.data.data.info.ac_three_stage>1){
                        //         this.activity = 'three'
                        //     }
                        // }
                    }else if(res.data.data.activity==3){
                        this.activity = 'three'
                        // if(res.data.data.info.current_stage==2){
                        //     this.activity = 'two'
                        //     this.twonextBtn = true
                        // }else if(res.data.data.info.current_stage==3){
                        //     this.activity = 'two'
                        //     this.twonextBtn = true
                        //     if(res.data.data.info.ac_three_stage>1){
                        //         this.activity = 'three'
                        //     }
                        // }else{
                        //     this.activity = 'three'
                        // }
                    }
                    if(res.data.data.info.ac_three_stage){
                        this.acThreeStage = res.data.data.info.ac_three_stage -1
                        this.activityThreeMap = this.mapList[this.acThreeStage]
                    }
                    if(res.data.data.info.ac_two_stage&&res.data.data.info.ac_two_stage>=0){
                        this.gettingAroundEssential = res.data.data.info.ac_two_stage
                    }
                   if(res.data.data.info.activity_one_choose){
                       this.reminiscencePhotoAlbum = true
                       this.profoundStory = false
                        if(res.data.data.info.activity_one_choose=='a'){
                            this.photoAlbum = this.photoAlbumList[0]
                        }else if(res.data.data.info.activity_one_choose=='b'){
                            this.photoAlbum = this.photoAlbumList[1]
                        }else if(res.data.data.info.activity_one_choose=='c'){
                            this.photoAlbum = this.photoAlbumList[2]
                        }
                        this.phasesChoose = res.data.data.info.ac_one_stage
                        if(this.phasesChoose==4){
                            this.albumTitleOne = false
                        }
                   }else{
                       this.profoundStory = true
                       this.reminiscencePhotoAlbum = false
                   }
                   if(res.data.data.info.is_share){
                       if(res.data.data.info.is_share==1){
                           this.shareIntegral()
                       }else if(res.data.data.info.is_share==3){
                           this.shareOf = false
                       }
                   }
                   if(res.data.data.info.complete_one_status){
                       this.completeStatusOne = res.data.data.info.complete_one_status
                   }
                   if(res.data.data.info.complete_two_status){
                       this.completeStatusTwo = res.data.data.info.complete_two_status
                   }
                   if(res.data.data.info.complete_three_status){
                       this.completeStatusThree = res.data.data.info.complete_three_status
                   }
                   if(res.data.data.isRemind==1){
                       if(!window.localStorage.getItem('isRemind')){
                                // 提醒地址填写弹框
                            this.tipsFillAddressIinformation = true
                            this.styleOverflew='overflow-y: hidden;'
                        }
                   }
                    // if(JSON.stringify(this.userinfo)=='{}'){
                    //     if(res.data.data.info.is_owner==1){
                    //         this.track('moonFestival_pageView','',this.scource,'','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html', res.data.data.info.user_id, 'bindUser')
                    //     }else{
                            // this.track('moonFestival_pageView','',this.scource, '','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html',res.data.data.info.user_id, 'unbindUser')
                    //     }
                    // }              
                    this.userinfo = res.data.data
                    // console.log(this.qc(res.data.data.info.picture))
                    //1是车主2不是车主
                    // this.userinfo = {
                    //     isOwner:res.data.data.isOwner,
                    //     id:res.data.data.info.id
                    // }
                }else{
                    this.getUserToken();
                    // this.toastContent = '系统繁忙，请稍后再试'
                    // this.toastPopup = true
                    // setTimeout(() => {
                    //     this.toastPopup = false
                    //     this.toastContent = ''
                    // }, 1500);
                    
                }
            }).catch((err)=>{
                this.toastContent = '系统繁忙，请稍后再试'
                this.toastPopup = true
                setTimeout(() => {
                    this.toastPopup = false
                    this.toastContent = ''
                }, 1500);
            })
        },
        
        // 加载
        loadFun(){
            let that = this
            let imgarr_rw = [
                "//res.xiaoxxx.com/test/m.xiaoxxx.com/2021070814a973e5ffe95e14611317.png",
            ];
            let imgarr_mg = [
                "//res.xiaoxxx.com/test/m.xiaoxxx.com/202107121a85fa576aeadb87407582.png",
            ];
            var iii = 0;
            var iiiarr = 23;
            var imgarr = that.apptype == "Roewe" ? imgarr_rw : imgarr_mg;
            for (var i = 0; i < imgarr.length; i++) {
                var img = new Image();
                // console.log("第" + iii + "个img开始")
                img.onload = function () {
                    iii = iii + 1;
                    // console.log("第" + iii + "个img加载完成")
                    that.loading_num = Math.floor(
                        ((iiiarr - (iiiarr - iii)) / iiiarr) * 100
                    );
                    if (iiiarr === iii) {
                        // console.log("第一批图片加载完成")
                        setTimeout(() => {
                            that.isloading = false
                            
                        }, 1500);
                    }
                };
                img.onerror = function () {
                // console.log("第" + iii + "个img加载error")
                };
                img.src = imgarr[i];
            }
        }
    },
}
</script>
